module.exports = __webpack_public_path__ + "static/img/商业智能-2.24d28502.png";